import { css } from "@emotion/css";
import { ExternalLink } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import React from "react";
import ProcessTemplatesHelpImage from "~/areas/platformHub/processTemplates/assets/ProcessTemplateHelpImage.svg";
import { LearnMoreResources, OverviewContainer, OverviewHighlightText, TopicsContainer } from "~/components/ContextualHelpLayout/PageHelpRegistry/Registrations/CommonComponents/CommonViews";
import ImageWithPlaceholder from "~/components/GettingStarted/ImageWithPlaceholder/ImageWithPlaceholder";
const overviewStyles = css({
    marginTop: space[12],
});
export const CommonProcessTemplateOverview = () => {
    return (<OverviewContainer>
            <OverviewHighlightText>
                <ExternalLink href="process-templates">Process Templates</ExternalLink> are reusable blocks of deployment steps to standardize deployment processes, reducing duplication across teams.
                <div className={overviewStyles}>
                    Templates are stored in Git as OCL, with full version control. Application teams can then insert one or more process templates into their deployment processes or runbooks, customizing them with configuration specific to their
                    projects.
                </div>
            </OverviewHighlightText>
            <ImageWithPlaceholder src={ProcessTemplatesHelpImage} alt={"Process templates help image"}/>
        </OverviewContainer>);
};
export const CommonProcessTemplateTopics = () => {
    return (<TopicsContainer>
            <LearnMoreResources title="Getting started guides">
                <ExternalLink href="process-templates">Overview of Process Templates</ExternalLink>
                <ExternalLink href="process-templates-best-practices">Process Templates Best Practices</ExternalLink>
            </LearnMoreResources>
        </TopicsContainer>);
};
